import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";
import * as env from "shared/env";

export const styles = (theme: Theme) => {
	return ({
		itemWrapper: {
			display: "flex",
		},
		item: {
			flex: 1,
			marginLeft: 40,
			marginRight: 16,
			paddingRight: 16,
			marginTop: 15,
			height: 50,
			borderRadius: 10,
			color: theme.palette.custom.navText,
			boxShadow: "none",
			whiteSpace: "nowrap",
			overflow: "hidden",
			textOverflow: "ellipsis",
			textTransform: "none",
			justifyContent: "unset",
		},
		active: {
			backgroundColor: alpha(theme.palette.secondary.main, 0.4),
			color: theme.palette.custom.navText,
			fontWeight: "bold",
			fontSize: 16,
			"&:hover": {
				backgroundColor: alpha(theme.palette.secondary.main, 0.15),
			},
		},
		inactive: {
			fontWeight: 300, fontSize: 16,
		},
		groupItemChildActive: {
			fontWeight: "bold" as const,
		},
		groupContainer: {},
		groupContainerActive: {},
		icon: {
			marginRight: 6,
		},
		chevron: {
			marginLeft: "auto",
			marginTop: 5,
		},
	} satisfies Record<string, CSSObject>)
}
